import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  "data-cy": "accountingWorkspace-groupName",
  class: "d-flex align-center primary--text"
}
const _hoisted_2 = {
  key: 0,
  "data-cy": "accountingWorkspace-dossierName"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "d-flex align-center primary--text" }
const _hoisted_5 = { class: "d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_TutorialButtonDialog = _resolveComponent("TutorialButtonDialog")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_virtual_scroll = _resolveComponent("v-virtual-scroll")!
  const _component_AccountingWorkspace = _resolveComponent("AccountingWorkspace")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pb-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        cols: "12",
        class: "pb-2"
      }, {
        default: _withCtx(() => [
          (_ctx.enableWrite)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_primary, {
                    "data-cy": "accountingWorkspace-add",
                    block: "",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogCreateAccountingWorkspace = !_ctx.dialogCreateAccountingWorkspace))
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" Ajouter ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, { class: "pl-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                label: "Recherche",
                "append-inner-icon": "$search",
                clearable: "",
                "onClick:clear": _cache[2] || (_cache[2] = ($event: any) => (_ctx.search = '')),
                outlined: "",
                "hide-details": "",
                density: "compact",
                "data-cy": "accountingWorkspace-searchGroup"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (!_ctx.$vuetify.display.mobile)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 1,
                cols: "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_TutorialButtonDialog, { starterComponents: 'AccountingWorkspaces;' })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.accountingWorkspaces.length)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "d-flex justify-center",
            style: _normalizeStyle('max-height:' + _ctx.maxHeight + ';' + 'overflow:auto')
          }, [
            _createVNode(_component_v_virtual_scroll, {
              cols: _ctx.$vuetify.display.mobile ? '12' : '8',
              class: "my-0 pa-2",
              items: _ctx.sortedAccountingWorkspaces
            }, {
              default: _withCtx(({ item: accWorkspace }) => [
                _createVNode(_component_v_card, {
                  class: "default_card my-2",
                  elevation: "0",
                  "pa-0": "",
                  style: {"margin":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "d-flex align-center" }, {
                      default: _withCtx(() => [
                        (!_ctx.$vuetify.display.mobile)
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "2",
                              onClick: ($event: any) => (_ctx.editAccountingWorkspace(accWorkspace)),
                              class: "d-flex align-center justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  color: "secondary",
                                  class: "icon",
                                  size: "x-large"
                                }, {
                                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createTextVNode(" $apartment ")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_v_col, {
                          cols: _ctx.$vuetify.display.mobile ? '10' : '8',
                          onClick: ($event: any) => (_ctx.editAccountingWorkspace(accWorkspace))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                              _createElementVNode("span", {
                                class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                style: {"font-weight":"bold","font-size":"16pt"}
                              }, _toDisplayString(accWorkspace.name), 3)
                            ]),
                            (
                                        accWorkspace.clientCompanies &&
                                        accWorkspace.clientCompanies.length
                                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                  _createVNode(_component_v_icon, {
                                    size: "x-small",
                                    class: "mr-2"
                                  }, {
                                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                                      _createTextVNode("$fa-building")
                                    ])),
                                    _: 1
                                  }),
                                  _cache[10] || (_cache[10] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"11pt"} }, "Dossiers affectés : ", -1)),
                                  _createTextVNode(_toDisplayString(_ctx.displayClientCompanies(accWorkspace)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (accWorkspace.users && accWorkspace.users.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                  _createVNode(_component_v_icon, {
                                    size: "x-small",
                                    class: "mr-2"
                                  }, {
                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                      _createTextVNode("$fa-user")
                                    ])),
                                    _: 1
                                  }),
                                  _cache[12] || (_cache[12] = _createElementVNode("span", { style: {"font-weight":"bold","font-size":"11pt"} }, "Utilisateurs affectés : ", -1)),
                                  _createTextVNode(_toDisplayString(_ctx.displayWorkspaceUsers(accWorkspace)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["cols", "onClick"]),
                        _createVNode(_component_v_col, {
                          cols: "2",
                          class: "d-flex justify-space-around align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_tooltip, { location: "bottom" }, {
                              activator: _withCtx(({ props }) => [
                                _createVNode(_component_v_btn_icon, _mergeProps(props, {
                                  icon: "$oss-edit",
                                  color: "green",
                                  elevation: "0",
                                  onClick: ($event: any) => (_ctx.editAccountingWorkspace(accWorkspace)),
                                  size: "small"
                                }), null, 16, ["onClick"])
                              ]),
                              default: _withCtx(() => [
                                _cache[13] || (_cache[13] = _createElementVNode("span", null, "Modifier", -1))
                              ]),
                              _: 2
                            }, 1024),
                            (_ctx.enableWrite)
                              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                  key: 0,
                                  location: "bottom"
                                }, {
                                  activator: _withCtx(({ props }) => [
                                    _createVNode(_component_v_btn_trash, _mergeProps(props, {
                                      onClick: ($event: any) => {
                                                _ctx.selectedAccountingWorkspace = accWorkspace;
                                                _ctx.dialogDisconnectAccountingWorkspace = true;
                                            },
                                      size: "small",
                                      color: "new_red"
                                    }), null, 16, ["onClick"])
                                  ]),
                                  default: _withCtx(() => [
                                    _cache[14] || (_cache[14] = _createElementVNode("span", null, "Supprimer", -1))
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["cols", "items"])
          ], 4))
        : (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            class: "d-flex justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: _ctx.$vuetify.display.mobile ? '12' : '6',
                class: "my-0 pa-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "default_card ma-0",
                    elevation: "0",
                    "pa-0": "",
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { class: "d-flex align-center" }, {
                        default: _withCtx(() => [
                          (!_ctx.$vuetify.display.mobile)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    color: "new_red",
                                    class: "icon",
                                    size: "x-large"
                                  }, {
                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                      _createTextVNode(" $apartment ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_col, {
                            cols: _ctx.$vuetify.display.mobile ? '10' : '8'
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : ''),
                                  style: {"font-weight":"bold","font-size":"16pt"}
                                }, " Aucun espace de travail ", 2)
                              ]),
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.$vuetify.display.mobile ? 'ml-2' : '')
                                }, " Vous n'avez enregistré aucun espace de travail ", 2)
                              ])
                            ]),
                            _: 1
                          }, 8, ["cols"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["cols"])
            ]),
            _: 1
          })),
      (_ctx.dialogCreateAccountingWorkspace)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 2,
            modelValue: _ctx.dialogCreateAccountingWorkspace,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dialogCreateAccountingWorkspace) = $event)),
            title: 'Créer un espace de travail',
            actions: _ctx.actions,
            width: "1000px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AccountingWorkspace, {
                actions: _ctx.actions,
                accountingFirmId: _ctx.accountingFirm.id,
                onAccountingWorkspaceCreated: _ctx.refreshAccountingWorkspaces
              }, null, 8, ["actions", "accountingFirmId", "onAccountingWorkspaceCreated"])
            ]),
            _: 1
          }, 8, ["modelValue", "actions"]))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialogDisconnectAccountingWorkspace,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogDisconnectAccountingWorkspace) = $event)),
        "max-width": !_ctx.$vuetify.display.mobile ? '650px' : undefined,
        fullscreen: _ctx.$vuetify.display.mobile,
        "hide-overlay": _ctx.$vuetify.display.mobile,
        title: "Supprimer l'espace de travail",
        "valid-title": "Retirer",
        onValid: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteAccountingWorkspace(_ctx.selectedAccountingWorkspace)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "mx-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _cache[16] || (_cache[16] = _createTextVNode(" Vous êtes sur le point de supprimer le groupe de dossiers ")),
                  _createElementVNode("b", null, _toDisplayString(_ctx.selectedAccountingWorkspace.name), 1),
                  _cache[17] || (_cache[17] = _createTextVNode(". Confirmer la suppression ? "))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay"]),
      (_ctx.dialogEditAccountingWorkspace)
        ? (_openBlock(), _createBlock(_component_oss_dialog, {
            key: 3,
            modelValue: _ctx.dialogEditAccountingWorkspace,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogEditAccountingWorkspace) = $event)),
            title: "Edition de l'espace de travail",
            actions: _ctx.actions,
            width: "1000px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_AccountingWorkspace, {
                actions: _ctx.actions,
                accountingFirmId: _ctx.accountingFirm.id,
                existingAccountingWorkspace: _ctx.selectedAccountingWorkspace,
                onAccountingWorkspaceUpdated: _ctx.refreshAccountingWorkspaces
              }, null, 8, ["actions", "accountingFirmId", "existingAccountingWorkspace", "onAccountingWorkspaceUpdated"])
            ]),
            _: 1
          }, 8, ["modelValue", "actions"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}